import React from "react";
import { InputAdornment } from "@mui/material";
import { Search } from "@mui/icons-material";
import { CustomSearchTextField } from "../../../../../Components/CustomMuiComponents";
import { StatusContext } from "../Context/StatusActividadContext";

export default function FilterStatusActividad() {
  const { filter, setFilter } = React.useContext(StatusContext);
  return (
    <CustomSearchTextField
      placeholder="Buscar"
      size="small"
      variant="outlined"
      value={filter}
      onChange={(e) => setFilter(e.target.value)}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <Search />
          </InputAdornment>
        ),
      }}
    />
  );
}
